export const TutorialPillsNotification = {
  if: true,
  state: {
    // KEY-IN-STATE — `TutorialGifNotification` resolves both through
    // `el.call('polyglot', …)` at its own render site.
    descr: 'learn.tutorial.symbolsCodeExplained.descr',
    src: 'code-preview.gif',
    title: 'learn.tutorial.symbolsCodeExplained.title',
    key: 'symbolsCodeExplained',
    docsArticle: '/building-in-symbols'
  },
  Img: {},
  Hgroup: {},
  TutorialNotificationButtons: null,
  extends: 'TutorialGifNotification',
  theme: null,
  overflow: null
}
